import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "100%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Supplier prices")])]), _vm.wine ? _c(VCardText, [_c("div", {
    staticClass: "wine-naming"
  }, [_c("WineNaming", {
    key: "wine-naming-".concat(_vm.wine.id_wine),
    attrs: {
      wineNamingData: _vm.wine.naming_data,
      isPrefixWinery: true,
      isSuffixBottling: true,
      isSuffixType: true
    }
  })], 1), _c("div", [_vm._v(" Sold in " + _vm._s(_vm.casingWines.find(function (x) {
    return x.value == _vm.wine.casings.find(function (x) {
      return x.isDefault;
    }).casingId;
  }).text.toLowerCase()) + " ")]), _c("div", [_vm._v(" COGS: " + _vm._s(_vm.formatPrice(_vm.wine.cogs_euro_ex_vat)) + " " + _vm._s(_vm.getSymbolCurrency("EUR")) + " ")]), _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", [_c("div", [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "Search for a wine",
      clearable: "",
      "hide-details": "auto",
      loading: _vm.isLoading,
      "append-icon": "fa-search"
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.label != _vm.searchLabelLastUsed && _vm.search();
      },
      "click:append": function clickAppend($event) {
        return _vm.search();
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search();
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.suppliers.length === 0,
      items: _vm.suppliers,
      label: "Supplier",
      "hide-details": "auto",
      "item-text": "display_name",
      "item-value": "id",
      "hide-no-data": "",
      clearable: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.suppliers != _vm.searchSuppliersLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.suppliers,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "suppliers", $$v);
      },
      expression: "formSearch.suppliers"
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.vintages.length === 0,
      items: _vm.vintages,
      label: "Vintage",
      "hide-details": "auto",
      "hide-no-data": "",
      clearable: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.vintages != _vm.searchVintagesLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.vintages,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "vintages", $$v);
      },
      expression: "formSearch.vintages"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.bottlings,
      readonly: _vm.wineId > 0,
      label: "Bottling",
      "hide-details": "auto",
      "hide-no-data": "",
      clearable: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.bottlings != _vm.searchBottlingsLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.bottlings,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "bottlings", $$v);
      },
      expression: "formSearch.bottlings"
    }
  })], 1)])])]), _c("div", [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.items,
      "loading-text": "Loading... Please wait"
    },
    scopedSlots: _vm._u([{
      key: "item.isMatch",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c(VCheckbox, {
          staticStyle: {
            width: "fit-content"
          },
          on: {
            change: function change($event) {
              return _vm.updateWineSupplierPrice(item);
            }
          },
          model: {
            value: item.isMatch,
            callback: function callback($$v) {
              _vm.$set(item, "isMatch", $$v);
            },
            expression: "item.isMatch"
          }
        })], 1)];
      }
    }, {
      key: "item.bottling",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(item.bottling) + "ml")];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.createdAt)) + " ")];
      }
    }, {
      key: "item.price",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.price)) + " " + _vm._s(_vm.getSymbolCurrency("EUR")) + " ")];
      }
    }, {
      key: "item.rawData",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [item.rawData ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: true
          },
          on: {
            click: function click($event) {
              return _vm.showRawData(item);
            }
          }
        }, [_vm._v(" details ")]) : _vm._e()], 1)];
      }
    }, {
      key: "item.action",
      fn: function fn(_ref6) {
        var _item$comment;
        var item = _ref6.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c(VIcon, {
          staticClass: "fas fa-comment",
          attrs: {
            small: "",
            title: (_item$comment = item.comment) !== null && _item$comment !== void 0 ? _item$comment : "Comment"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.showComment(item);
            }
          }
        }), _vm.supplierId && _vm.isAllowToApplyPrice ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary ml-2",
          attrs: {
            rounded: true
          },
          on: {
            click: function click($event) {
              return _vm.applySupplierPrice(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-arrow-down"
        }), _vm._v(" Apply price ")]) : _vm._e()], 1)];
      }
    }], null, true)
  }), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "80%"
    },
    model: {
      value: _vm.updateComment.dialogShown,
      callback: function callback($$v) {
        _vm.$set(_vm.updateComment, "dialogShown", $$v);
      },
      expression: "updateComment.dialogShown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.hideComment();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("div", {
    staticClass: "text-h5"
  }, [_vm._v("Comment")])]), _c(VCardText, [_c(VTextarea, {
    staticClass: "full v-text-field-no-label",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.updateComment.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.updateComment.form, "comment", $$v);
      },
      expression: "updateComment.form.comment"
    }
  })], 1), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.updateComment.disabledRemove,
      rounded: "",
      loading: _vm.updateComment.isPending
    },
    on: {
      click: function click() {
        _vm.updateComment.form.comment = null;
        _vm.saveComment();
      }
    }
  }, [_vm._v(" Remove comment ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.updateComment.isPending
    },
    on: {
      click: _vm.saveComment
    }
  }, [_vm._v(" Save comment ")])], 1)], 1)], 1), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "80%"
    },
    model: {
      value: _vm.rawDataDialogShown,
      callback: function callback($$v) {
        _vm.rawDataDialogShown = $$v;
      },
      expression: "rawDataDialogShown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.hideRawData();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("div", {
    staticClass: "text-h5"
  }, [_vm._v("Details")])]), _c(VCardText, [_vm.supplier ? _c("div", {
    staticClass: "wine-naming"
  }, [_vm._v(_vm._s("Supplier: ".concat(_vm.supplier.name)))]) : _vm._e(), _c("div", {
    staticClass: "pt-0"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      id: "tableDetails",
      headers: _vm.rawHeaders,
      items: _vm.rawData,
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    }
  })], 1)])], 1)], 1)], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold"
  }, [_vm._v("Add new supplier price")])]), _c(VExpansionPanelContent, [_c("div", [_vm._v(" Product COGS: " + _vm._s(_vm.formatPrice(_vm.wine.cogs_euro_ex_vat)) + " " + _vm._s(_vm.getSymbolCurrency("EUR")) + " ")]), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.selectDefaultForAdd();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-dot-circle mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Default settings ")], 1)], 1), _c("NewSupplierPriceComponent", {
    ref: "newSupplierPriceComponent",
    attrs: {
      suppliers: _vm.suppliers,
      isLoading: _vm.isLoading,
      isAdding: _vm.isAdding,
      wineId: _vm.selectedWineId
    },
    on: {
      addSupplierPrice: _vm.addSupplierPrice,
      fetchSuppliersWhenItemsUpdated: _vm.fetchSuppliersWhenItemsUpdated
    }
  })], 1)], 1)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };